import { useEffect, useState } from 'react';

/**
 * R14 — debounce a fast-changing value (the inbox search, updated on every
 * keystroke) so the query key only changes after the operator pauses. Without
 * this, each character fires a new `/threads` request + count refetch.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
